import React from "react";
import { QuantityTiersField } from "@codway-dev/ui";
import { mapQuantityTiersResolvedDataToFieldProps } from "@codway-dev/shared";
import { useShopCurrency } from "../../../hooks/useShopCurrency";
import type { UpsellEmbedPreviewProps } from "./types";

export const QuantityTiersEmbedPreview: React.FC<UpsellEmbedPreviewProps> = ({
  resolvedData,
}) => {
  const { formatPrice } = useShopCurrency();
  if (!resolvedData) return null;

  const fieldProps = mapQuantityTiersResolvedDataToFieldProps(
    resolvedData,
    formatPrice
  );
  if (!fieldProps) return null;

  return (
    <QuantityTiersField
      tiers={fieldProps.tiers}
      selectedIndex={null}
      onSelect={() => {}}
      layout={fieldProps.layout}
      disabled
    />
  );
};
